import dayjs from 'dayjs';

import { dateTime } from '@/_shared';

export const now = dayjs().startOf('day').toDate();
export const yesterday = dateTime.subtract(now, 1, 'day').startOf('day').toDate();

export const durationOptions = [
  { value: 'thisMonth', label: 'This Month' },
  { value: 'thisQuarter', label: 'This Quarter' },
  { value: 'thisYear', label: 'This Year' },
  { value: 'lastMonth', label: 'Last Month' },
  { value: 'lastQuarter', label: 'Last Quarter' },
  { value: 'lastYear', label: 'Last Year' },
  { value: 'rolling12Months', label: 'Rolling Last 12 Months' },
  { value: 'custom', label: 'Custom Date Range' },
];

export const DEFAULT_DURATION = durationOptions[2];

export function convertDurationToDateRange(duration: { value: string; label: string }): string {
  if (duration.value.includes(',')) {
    // Custom date range
    return duration.value;
  }

  // Predefined ranges
  switch (duration.label) {
    case 'This Month':
      return 'this_month';
    case 'This Quarter':
      return 'this_quarter';
    case 'This Year':
      return 'this_year';
    case 'Last Month':
      return 'last_month';
    case 'Last Quarter':
      return 'last_quarter';
    case 'Last Year':
      return 'last_year';
    case 'Rolling 12 Months':
    default:
      return 'rolling_last_12_months';
  }
}
